import 'Styles/templates/index.scss';

import LazyVideo from '../components/lazy-video';
import productSliderApp from '../vue/product-slider/index';

import { createSwiper } from '../components/swiper';

LazyVideo();
productSliderApp();

var galleryThumbs = createSwiper('.bws__thumbs', {
  slidesPerView: 2,
  spaceBetween: 0,
  slideClass: 'swiper__col', 
  wrapperClass: 'swiper__row',
  allowTouchMove: false,
  breakpoints: { // when window width is >= 768
    768: {
      slidesPerView: 3,
      spaceBetween: 12,
    }
  },
  a11y: {
    enabled: true
  }
});

var galleryMain = createSwiper('.bws__main', {
  slidesPerView: 1,
  spaceBetween: 16,
  slideClass: 'swiper__col', 
  wrapperClass: 'swiper__row',
  effect: 'fade',
  allowTouchMove: false,
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.bws__next',
    prevEl: '.bws__prev'
  },
  thumbs: {
    swiper: galleryThumbs
  }
});